export const UPLOAD_SESSION_STATUS_VALUES = {
  processing: 'processing',
  complete: 'complete',
  partial: 'partial',
} as const;

export type UploadSessionStatus =
  (typeof UPLOAD_SESSION_STATUS_VALUES)[keyof typeof UPLOAD_SESSION_STATUS_VALUES];

export const UPLOAD_SESSION_STATUS_LABELS: Record<UploadSessionStatus, string> =
  {
    processing: 'Processing',
    complete: 'Uploaded',
    partial: 'Partial',
  };
